import axios from "axios";
import { ref } from "vue";
import { API_URL } from "../../types/consts.js";

export async function getDataRsvpByOwner(ownerName) {
  const rspvData = ref([]);
  const endpoint = `${API_URL}/carousels/owner/${ownerName}`;

  try {
    const response = await axios.get(endpoint);
    rspvData.value = response.data.data;
    console.log("Data fetched successfully:", rspvData.value);
    return rspvData;
  } catch (error) {
    console.error("There has been a problem with your fetch operation:", error);
  }
}
